import * as React from 'react'
import Image from 'next/image'
import { styled } from '@mui/material/styles'

import Stack from '@mui/material/Stack'
import Grid from '@mui/material/Grid'

import { I18n, useTranslation } from 'components/hooks/use-translation'
import Text from 'components/atomic/atoms/text'

import { Path } from 'types/types'

const OutcomeImage = styled('div')`
    position: relative;
    width: 14rem;
    min-height: 8rem;

    @keyframes pulse {
        0% {
            opacity: 0.4;
        }
        50% {
            opacity: 1;
        }
        100% {
            opacity: 0.4;
        }
    }

    animation: pulse 3s infinite ease-in-out;

    ${({ theme }) => theme.breakpoints.down('md')} {
        margin: 0 auto;
    }
`

const Outcomes = (props: Path) => {
    const { t }: I18n = useTranslation()

    return (
        <Stack>
            <Stack spacing={1}>
                <Text variant="h4">{t('path:targetSection.goalsTitle')}</Text>
                <Text color="text.secondary">{t('path:targetSection.goalsSubtitle')}</Text>
            </Stack>
            <Grid container>
                {props.outcomes.map((item, index) => (
                    <Grid item xs={12} sm md={4} key={index} p={2} sx={{ mt: { xs: '3rem', md: '2rem' } }}>
                        <Stack key={item._id} spacing="1rem" alignItems="center">
                            <OutcomeImage>
                                <Image
                                    layout="fill"
                                    src={`/assets/path-outcomes/${index + 1}.png`}
                                    alt={`Path outcome ${index + 1}`}
                                />
                            </OutcomeImage>
                            <Text sx={{ width: '100%', textAlign: { xs: 'center', md: 'center' } }} variant="h6">
                                {item.title}
                            </Text>
                            <Text sx={{ textAlign: { xs: 'center', md: 'center' } }} color="text.secondary">
                                {item.description}
                            </Text>
                        </Stack>
                    </Grid>
                ))}
            </Grid>
        </Stack>
    )
}

export default Outcomes
